// Axios instance with Bearer auth + small helpers.
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "aurea_admin_token";

export const getToken = () => {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
};

export const setToken = (t) => {
    try {
        if (t) localStorage.setItem(TOKEN_KEY, t);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        // ignore
    }
};

export const api = axios.create({
    baseURL: `${BASE}/api`,
    timeout: 20000,
});

api.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401) {
            // Token expired or invalid — clear locally; routes will redirect to /admin.
            setToken(null);
        }
        return Promise.reject(err);
    },
);

// Helper to render FastAPI error detail safely as a string.
export const formatApiError = (err) => {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Something went wrong.";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (typeof d?.msg === "string") return d.msg;
    return String(d);
};

// Resolve an upload URL returned by the API ('/api/public/uploads/<id>') to an
// absolute URL the browser can fetch.
export const resolveUploadUrl = (url) => {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith("/api/")) return `${BASE}${url}`;
    return url;
};
